<i18n lang="yaml">
ru:
  filters: 'Фильтры:'
en:
  filters: 'Filters:'
</i18n>

<template>
  <div class="filters-wrapper">
    <div v-if="propertiesFilters.length" class="filters filters-desktop">
      <span class="filters-main">{{ $t('filters') }}</span>
      <filters-item v-for="prop in propertiesFilters" :key="prop.id" :prop="prop" @set-filter="setFilter"
                    :initial-query="initialQuery"/>
    </div>
    <div v-if="propertiesFilters.length" class="filters-mobile">
      <filters-item v-for="prop in propertiesFilters" :key="prop.id" :prop="prop" @set-filter="setFilter"
                    @set-selected-filters="setSelectedFilters"
                    :initial-query="initialQuery"/>
    </div>
  </div>
</template>

<script>
import {ProductProperty} from '@/models/product';

import FiltersItem from '@/components/catalog/filters-item';

export default {
  components: {
    FiltersItem,
  },
  props: ['initialQuery', 'category'],
  data() {
    return {
      productProperties: [],
      filterOpen: null
    }
  },
  watch: {
    async queryParams() {
      await this.$axios.$get(
        '/catalog/property/filters/',
        {params: this.queryParams}
      ).then(
        (response) => this.productProperties = response
      );
    },
  },
  computed: {
    propertiesFilters() {
      return this.productProperties.filter(x => x.use_filter && x.filters.length);
    },
    queryParams() {
      const params = {...this.$route.query};
      if (this.category) {
        params.category = this.category.id;
      }
      if (this.favourites) {
        params.favourites = 1;
      }
      if (this.searchHistory) {
        params.search_history_id = this.searchHistory.id;
      }
      return params;
    },
  },
  async fetch() {
    this.productProperties = await this.$axios.$get('/catalog/property/filters/', {params: this.queryParams, count_loading: true});
  },
  methods: {
    setFilter(propId, value) {
      this.$emit('set-filter', propId, value);
    },
    setSelectedFilters(propId, value) {
      this.$emit('set-selected-filters', propId, value);
    },
  }
}
</script>
